export default class AppVersion {
  public id!: string;
  public os!: string;
  public build!: number;
  public version!: string;
  public download_url!: string;

  public created_at?: Date;
}
